import { render, staticRenderFns } from "./AccountSettingsTab.vue?vue&type=template&id=6dbe2718&scoped=true&"
import script from "./AccountSettingsTab.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe2718",
  null
  
)

export default component.exports